import { Season } from "@/enums";
import { CurriculumUnit } from "@/models";

/**
 * An array of CurriculumUnit objects used to mock or fake data for configuring and testing redux slices.
 * Each object represents a unit in the curriculum with properties such as id, curriculumPlanId,
 * unitName, season, and lessons.
 */
export const CurriculumUnits: CurriculumUnit[] = [
  {
    id: "unit-1",
    curriculumPlanId: 20,
    unitName: "Unit 1",
    season: Season.FALL,
    lessons: [],
  },
  {
    id: "unit-2",
    curriculumPlanId: 20,
    unitName: "Unit 2",
    season: Season.WINTER,
    lessons: [],
  },
  {
    id: "unit-3",
    curriculumPlanId: 20,
    unitName: "Unit 3",
    season: Season.SPRING,
    lessons: [],
  },
  {
    id: "unit-4",
    curriculumPlanId: 20,
    unitName: "Unit 4",
    season: Season.SPRING,
    lessons: [],
  },
  {
    id: "unit-5",
    curriculumPlanId: 20,
    unitName: "Unit 5",
    season: Season.WINTER,
    lessons: [],
  },
  {
    id: "unit-6",
    curriculumPlanId: 20,
    unitName: "Unit 6",
    season: Season.FALL,
    lessons: [],
  },
  {
    id: "unit-7",
    curriculumPlanId: 20,
    unitName: "Unit 7",
    season: Season.FALL,
    lessons: [],
  },
  {
    id: "unit-8",
    curriculumPlanId: 20,
    unitName: "Unit 8",
    season: Season.SPRING,
    lessons: [],
  },
  {
    id: "unit-9",
    curriculumPlanId: 20,
    unitName: "Unit 9",
    season: Season.WINTER,
    lessons: [],
  },
  {
    id: "unit-10",
    curriculumPlanId: 20,
    unitName: "Unit 10",
    season: Season.FALL,
    lessons: [],
  },
  {
    id: "unit-11",
    curriculumPlanId: 20,
    unitName: "Unit 11",
    season: Season.WINTER,
    lessons: [],
  },
  {
    id: "unit-12",
    curriculumPlanId: 20,
    unitName: "Unit 12",
    season: Season.SPRING,
    lessons: [],
  }
];